export default __webpack_public_path__ + "static/404-9a754e7efdf4b17d872306e87110a7a6.png";